$(window).on('load', function() {
  const $mainContainer = $('.main-container');
  const $banner = $mainContainer.find('.adfox-topfirst');
  if($banner.children().length == 0) {
    $mainContainer.addClass('main-container--no-adfox')
  } else if($banner.children().length > 0){
    $mainContainer.removeClass('main-container--no-adfox')
  }
});


// WEBPACK FOOTER //
// ./resources/assets/js/blocks/adfox-check/index.js